import { render, staticRenderFns } from "./Spedy.vue?vue&type=template&id=106173ec&scoped=true&"
import script from "./Spedy.vue?vue&type=script&lang=js&"
export * from "./Spedy.vue?vue&type=script&lang=js&"
import style0 from "./Spedy.vue?vue&type=style&index=0&id=106173ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106173ec",
  null
  
)

export default component.exports